import {
  TableDateCell,
  TableEmptyCell,
  TableFlatCell,
  TableFloatCell,
  TableFloorCell,
  TablePropertyShareCell,
  TableRoleCell,
  TableStatusCell,
  TableTextCell,
  TableUserCell,
  TableUserListCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'

import {
  CONTRACT_COLUMN_NAME,
  CONTRACT_FIELD_BY_COLUMN_NAME,
} from './EntityTabContractTableRow.constants'

export function renderContractCell({
  durationUnit,
  item,
  name,
  statuses,
  ...cellProps
}) {
  const field = CONTRACT_FIELD_BY_COLUMN_NAME[name] ?? name

  const value = item[field]

  switch (field) {
    case CONTRACT_COLUMN_NAME.ContractId:
    case CONTRACT_COLUMN_NAME.SecondContractId:
    case CONTRACT_COLUMN_NAME.HeatType:
    case CONTRACT_COLUMN_NAME.EntranceAddress:
      return <TableTextCell {...cellProps} value={value} />

    case CONTRACT_COLUMN_NAME.ContractStart:
    case CONTRACT_COLUMN_NAME.ContractEnd:
    case CONTRACT_COLUMN_NAME.DelayedDate:
      return <TableDateCell {...cellProps} value={value} />

    case CONTRACT_COLUMN_NAME.Duration:
      return (
        <TableTextCell
          {...cellProps}
          value={value == null ? null : `${value} ${durationUnit}`}
        />
      )

    case CONTRACT_COLUMN_NAME.Flat:
      return <TableFlatCell {...cellProps} value={value} />

    case CONTRACT_COLUMN_NAME.Building:
      return <TableTextCell {...cellProps} value={value?.title} />

    case CONTRACT_COLUMN_NAME.Category:
      return <TableTextCell {...cellProps} value={value?.value} />

    case CONTRACT_COLUMN_NAME.PropertyShare:
      return <TablePropertyShareCell {...cellProps} value={value} />

    case CONTRACT_COLUMN_NAME.RoomCount:
      return (
        <TableTextCell
          {...cellProps}
          value={value == null ? null : `${value}`}
        />
      )

    case CONTRACT_COLUMN_NAME.Floor:
      return <TableFloorCell {...cellProps} value={value} />

    case CONTRACT_COLUMN_NAME.Area:
    case CONTRACT_COLUMN_NAME.LiveArea:
      return <TableFloatCell {...cellProps} value={value} />

    case CONTRACT_COLUMN_NAME.Inhabitant:
      return (
        <TableUserCell
          {...cellProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case CONTRACT_COLUMN_NAME.InhabitantRole:
      return <TableRoleCell {...cellProps} value={item.inhabitant?.role} />

    case CONTRACT_COLUMN_NAME.InhabitantStatus:
      return (
        <TableStatusCell
          {...cellProps}
          statuses={statuses}
          value={item.inhabitant?.status}
        />
      )

    case CONTRACT_COLUMN_NAME.Landlords:
    case CONTRACT_COLUMN_NAME.Dwellers:
      return (
        <TableUserListCell
          {...cellProps}
          value={value?.map(user => toUserMultiValue(user))}
        />
      )

    default:
      return <TableEmptyCell {...cellProps} />
  }
}
